{
  "CANNED_MGMT": {
    "HEADER": "Réponses standardisées",
    "LEARN_MORE": "Learn more about canned responses",
    "DESCRIPTION": "Canned Responses are pre-written reply templates that help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a canned response during a conversation. ",
    "HEADER_BTN_TXT": "Ajouter une réponse prédéfinie",
    "LOADING": "Récupération des réponses prédéfinies...",
    "SEARCH_404": "Il n'y a aucun élément correspondant à cette requête.",
    "LIST": {
      "404": "Il n'y a aucune réponse standardisée disponible dans ce compte.",
      "TITLE": "Gérer les réponses standardisées",
      "DESC": "Les réponses prédéfinies sont des modèles de réponse prédéfinis qui peuvent être utilisés pour envoyer rapidement des réponses aux conversations.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Code court",
        "CONTENT": "Contenu",
        "INBOXES": "Boîtes de réception",
        "ACTIONS": "Actions"
      },
      "ALL_INBOXES": "Toutes les boîtes de réception",
      "FILTER": {
        "ALL_INBOXES": "Toutes les boîtes de réception",
        "NO_INBOX": "Aucune boîte de réception",
        "SEARCH_PLACEHOLDER": "Rechercher une boîte de réception"
      }
    },
    "ADD": {
      "TITLE": "Ajouter une réponse prédéfinie",
      "DESC": "Les réponses prédéfinies sont des modèles de réponse prédéfinis qui peuvent être utilisés pour envoyer rapidement des réponses aux conversations.",
      "CANCEL_BUTTON_TEXT": "Annuler",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Code court",
          "PLACEHOLDER": "Veuillez entrer un code court.",
          "ERROR": "Le code court est requis."
        },
        "SUBJECT": {
          "LABEL": "Objet (e-mail uniquement)",
          "PLACEHOLDER": "Objet facultatif pour les réponses e-mail / nouvelles conversations"
        },
        "CONTENT": {
          "LABEL": "Message",
          "PLACEHOLDER": "Veuillez écrire le message que vous voulez enregistrer comme modèle à utiliser plus tard.",
          "ERROR": "Le message est obligatoire."
        },
        "ATTACHMENTS": {
          "LABEL": "Pièces jointes"
        },
        "INBOXES": {
          "LABEL": "Boîtes de réception",
          "PLACEHOLDER": "Sélectionnez les boîtes de réception (facultatif, laissez vide pour toutes)"
        },
        "SUBMIT": "Envoyer"
      },
      "API": {
        "SUCCESS_MESSAGE": "La réponse prédéfinie a été ajoutée.",
        "ERROR_MESSAGE": "Impossible de se connecter au serveur Woot, veuillez réessayer plus tard"
      }
    },
    "EDIT": {
      "TITLE": "Éditer la réponse prédéfinie",
      "CANCEL_BUTTON_TEXT": "Annuler",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Code court",
          "PLACEHOLDER": "Veuillez entrer un code court.",
          "ERROR": "Le code court est requis."
        },
        "SUBJECT": {
          "LABEL": "Objet (e-mail uniquement)",
          "PLACEHOLDER": "Objet facultatif pour les réponses e-mail / nouvelles conversations"
        },
        "CONTENT": {
          "LABEL": "Message",
          "PLACEHOLDER": "Veuillez écrire le message que vous voulez enregistrer comme modèle à utiliser plus tard.",
          "ERROR": "Le message est obligatoire."
        },
        "ATTACHMENTS": {
          "LABEL": "Pièces jointes"
        },
        "INBOXES": {
          "LABEL": "Boîtes de réception",
          "PLACEHOLDER": "Sélectionnez les boîtes de réception (facultatif, laissez vide pour toutes)"
        },
        "SUBMIT": "Envoyer"
      },
      "BUTTON_TEXT": "Modifier",
      "API": {
        "SUCCESS_MESSAGE": "Réponse prédéfinie mise à jour.",
        "ERROR_MESSAGE": "Impossible de se connecter au serveur Woot, veuillez réessayer plus tard"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Supprimer",
      "API": {
        "SUCCESS_MESSAGE": "Réponse prédéfinie supprimée.",
        "ERROR_MESSAGE": "Impossible de se connecter au serveur Woot, veuillez réessayer plus tard"
      },
      "CONFIRM": {
        "TITLE": "Confirmer la suppression",
        "MESSAGE": "Êtes-vous sûr de vouloir supprimer ",
        "YES": "Oui, supprimer ",
        "NO": "Non, Conserver "
      }
    }
  }
}
